<!-- ── Admin top bar ─────────────────────────────────────────────────────── -->
<div style="background:#0f172a;color:#f8fafc;padding:0;position:sticky;top:0;z-index:100;box-shadow:0 1px 3px rgba(0,0,0,.4);">
  <div style="display:flex;align-items:center;justify-content:space-between;height:52px;padding:0 16px;max-width:1400px;margin:0 auto;">

    <!-- Nav links — horizontal scroll on mobile -->
    <div style="display:flex;align-items:center;gap:4px;overflow-x:auto;scrollbar-width:none;-ms-overflow-style:none;flex:1;min-width:0;">
      <span style="font-size:13px;font-weight:700;letter-spacing:1px;color:#38bdf8;text-transform:uppercase;white-space:nowrap;flex-shrink:0;margin-right:8px;">TG Admin</span>
      <span style="width:1px;height:18px;background:#334155;flex-shrink:0;margin-right:4px;"></span>
      <a (click)="navigate('/admin/scraper')"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Scraper</a>
      <span style="font-size:13px;font-weight:600;color:#f8fafc;padding:6px 10px;background:#1e3a5f;border-radius:4px;white-space:nowrap;flex-shrink:0;">Vacantes</span>
      <a (click)="navigate('/admin/usuarios')"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Usuarios</a>
      <a routerLink="/admin/gurumatch"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">GuruMatch</a>
      <a routerLink="/admin/suscripciones"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Suscripciones</a>
      <a (click)="navigate('/admin/config')"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Config</a>
      <a routerLink="/admin/social"
         style="font-size:13px;color:#94a3b8;text-decoration:none;cursor:pointer;padding:6px 10px;border-radius:4px;white-space:nowrap;flex-shrink:0;"
         onmouseover="this.style.color='#f8fafc'" onmouseout="this.style.color='#94a3b8'">Redes Sociales</a>
    </div>

    <!-- Action buttons — always visible -->
    <div style="display:flex;align-items:center;gap:6px;flex-shrink:0;margin-left:8px;">
      <button (click)="exportar()" [disabled]="exportando"
              style="display:inline-flex;align-items:center;gap:5px;background:#16a34a;color:#fff;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;"
              [style.opacity]="exportando ? '0.6' : '1'">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"/>
        </svg>
        {{ exportando ? 'Exportando...' : 'Exportar' }}
      </button>
      <button (click)="cerrarSesion()"
              style="display:inline-flex;align-items:center;gap:5px;background:#7f1d1d;color:#fca5a5;border:none;border-radius:6px;padding:6px 12px;font-size:12px;font-weight:600;cursor:pointer;white-space:nowrap;">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" style="width:13px;height:13px;flex-shrink:0;">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 9V5.25A2.25 2.25 0 0 0 13.5 3h-6a2.25 2.25 0 0 0-2.25 2.25v13.5A2.25 2.25 0 0 0 7.5 21h6a2.25 2.25 0 0 0 2.25-2.25V15M12 9l-3 3m0 0 3 3m-3-3h12.75"/>
        </svg>
        Salir
      </button>
    </div>
  </div>
</div>

<!-- ── Filters bar ───────────────────────────────────────────────────────── -->
<div style="background:#1e293b;padding:14px 0;border-bottom:1px solid #334155;">
  <div class="tg-container">
    <div style="display:flex;flex-wrap:wrap;gap:8px;align-items:center;">

      <!-- Buscar -->
      <input [(ngModel)]="filtros.buscar" (input)="onTexto()" placeholder="Buscar vacante…"
             style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;min-width:180px;outline:none;">

      <!-- Empresa -->
      <input [(ngModel)]="filtros.empresa" (input)="onTexto()" placeholder="Empresa…"
             style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;min-width:150px;outline:none;">

      <!-- Fecha desde -->
      <input type="date" [(ngModel)]="filtros.desde" (change)="onFiltro()"
             title="Desde"
             style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;color-scheme:dark;">

      <!-- Fecha hasta -->
      <input type="date" [(ngModel)]="filtros.hasta" (change)="onFiltro()"
             title="Hasta"
             style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;color-scheme:dark;">

      <!-- Fuente -->
      <select [(ngModel)]="filtros.fuente" (change)="onFiltro()"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;">
        <option value="">Todas las fuentes</option>
        <option value="manual">Manual</option>
        <option value="scraper">Scraper</option>
      </select>

      <!-- Estado -->
      <select [(ngModel)]="filtros.estado" (change)="onFiltro()"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#f8fafc;padding:6px 10px;font-size:12px;outline:none;">
        <option value="">Todos los estados</option>
        <option value="activa">Activas</option>
        <option value="inactiva">Inactivas</option>
      </select>

      <!-- Page size -->
      <select (change)="onSize($event)"
              style="background:#0f172a;border:1px solid #334155;border-radius:6px;color:#94a3b8;padding:6px 10px;font-size:12px;outline:none;">
        <option value="20" [selected]="size===20">20 / pág</option>
        <option value="50" [selected]="size===50">50 / pág</option>
        <option value="100" [selected]="size===100">100 / pág</option>
      </select>

      <!-- Limpiar -->
      <button (click)="limpiar()"
              style="background:transparent;border:1px solid #475569;border-radius:6px;color:#94a3b8;padding:6px 12px;font-size:12px;cursor:pointer;">
        Limpiar
      </button>

    </div>
  </div>
</div>

<!-- ── Summary row ───────────────────────────────────────────────────────── -->
<div style="background:#1e293b;padding:8px 0;border-bottom:1px solid #334155;">
  <div class="tg-container" style="display:flex;align-items:center;justify-content:space-between;">
    <span style="font-size:12px;color:#94a3b8;">
      <ng-container *ngIf="!cargando && totalElements > 0">
        Mostrando <strong style="color:#f8fafc;">{{desde}}–{{hasta}}</strong> de
        <strong style="color:#f8fafc;">{{totalElements}}</strong> vacantes
      </ng-container>
      <ng-container *ngIf="cargando">Cargando…</ng-container>
      <ng-container *ngIf="!cargando && totalElements === 0">Sin resultados</ng-container>
    </span>
  </div>
</div>

<!-- ── Table ─────────────────────────────────────────────────────────────── -->
<div style="background:#0f172a;min-height:60vh;overflow-x:auto;">
  <div class="tg-container">

    <!-- Loading skeleton -->
    <div *ngIf="cargando" style="padding:48px;text-align:center;color:#475569;font-size:14px;">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
           style="width:24px;height:24px;animation:spin 1s linear infinite;display:inline-block;margin-bottom:8px;">
        <path stroke-linecap="round" stroke-linejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"/>
      </svg>
      <div>Cargando vacantes…</div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!cargando && vacantes.length === 0"
         style="padding:64px;text-align:center;color:#475569;font-size:14px;">
      No se encontraron vacantes con los filtros aplicados.
    </div>

    <!-- Table -->
    <table *ngIf="!cargando && vacantes.length > 0"
           style="width:100%;border-collapse:collapse;font-size:13px;">
      <thead>
        <tr style="background:#1e293b;border-bottom:1px solid #334155;">
          <th style="width:36px;padding:10px 8px;"></th>
          <th (click)="sort('nombre')" class="th-sort" style="text-align:left;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;cursor:pointer;">
            Vacante {{sortIcon('nombre')}}
          </th>
          <th style="text-align:left;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;">
            Empresa
          </th>
          <th style="text-align:left;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;">
            Fuente
          </th>
          <th style="text-align:left;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;">
            Categoría
          </th>
          <th (click)="sort('status')" class="th-sort" style="text-align:center;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;cursor:pointer;">
            Estado {{sortIcon('status')}}
          </th>
          <th (click)="sort('createdAt')" class="th-sort" style="text-align:left;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;cursor:pointer;">
            Publicada {{sortIcon('createdAt')}}
          </th>
          <th style="text-align:center;padding:10px 12px;color:#94a3b8;font-weight:600;white-space:nowrap;">
            Postulaciones
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let v of vacantes">
          <!-- Main row -->
          <tr (click)="toggleRow(v.idVacante)"
              style="border-bottom:1px solid #1e293b;cursor:pointer;transition:background .12s;"
              [style.background]="rowExpanded(v.idVacante) ? '#1e2d42' : 'transparent'"
              (mouseover)="$event.currentTarget.style.background='#1e293b'"
              (mouseout)="$event.currentTarget.style.background=rowExpanded(v.idVacante)?'#1e2d42':'transparent'"
              [attr.data-id]="v.idVacante">

            <!-- Expand chevron -->
            <td style="padding:10px 8px;text-align:center;color:#475569;">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
                   style="width:14px;height:14px;transition:transform .2s;"
                   [style.transform]="rowExpanded(v.idVacante) ? 'rotate(90deg)' : 'rotate(0deg)'">
                <path stroke-linecap="round" stroke-linejoin="round" d="m8.25 4.5 7.5 7.5-7.5 7.5"/>
              </svg>
            </td>

            <!-- Nombre -->
            <td style="padding:10px 12px;color:#f1f5f9;max-width:280px;">
              <a [href]="'/vacantes/detalles/' + (v.urlVacante || v.idVacante)"
                 target="_blank"
                 (click)="$event.stopPropagation()"
                 style="display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-weight:500;color:#38bdf8;text-decoration:none;"
                 onmouseover="this.style.textDecoration='underline'" onmouseout="this.style.textDecoration='none'">
                {{v.nombre}}
              </a>
            </td>

            <!-- Empresa -->
            <td style="padding:10px 12px;color:#94a3b8;max-width:200px;">
              <span style="display:block;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">
                {{v.empresa}}
              </span>
            </td>

            <!-- Fuente badge -->
            <td style="padding:10px 12px;">
              <span [style.background]="v.scrapeFuente ? '#0c3355' : '#1c3229'"
                    [style.color]="v.scrapeFuente ? '#38bdf8' : '#4ade80'"
                    style="display:inline-block;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;text-transform:uppercase;letter-spacing:.4px;">
                {{fuenteBadge(v.scrapeFuente)}}
              </span>
            </td>

            <!-- Categoría -->
            <td style="padding:10px 12px;">
              <span *ngIf="v.categoriaNombre"
                    style="display:inline-block;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;background:#1e2d42;color:#93c5fd;white-space:nowrap;">
                {{v.categoriaNombre}}
              </span>
              <span *ngIf="!v.categoriaNombre"
                    style="color:#475569;font-size:11px;">—</span>
            </td>

            <!-- Estado -->
            <td style="padding:10px 12px;text-align:center;">
              <span [style.background]="v.status ? '#1c3229' : '#3b1c1c'"
                    [style.color]="v.status ? '#4ade80' : '#f87171'"
                    style="display:inline-block;padding:2px 8px;border-radius:4px;font-size:11px;font-weight:600;">
                {{v.status ? 'Activa' : 'Inactiva'}}
              </span>
            </td>

            <!-- Fecha -->
            <td style="padding:10px 12px;color:#64748b;white-space:nowrap;font-size:12px;">
              {{formatDate(v.createdAt)}}
            </td>

            <!-- Postulaciones -->
            <td style="padding:10px 12px;text-align:center;">
              <span [style.color]="v.totalPostulaciones > 0 ? '#fbbf24' : '#475569'"
                    [style.fontWeight]="v.totalPostulaciones > 0 ? '700' : '400'"
                    style="font-size:15px;">
                {{v.totalPostulaciones}}
              </span>
            </td>
          </tr>

          <!-- Sub-grid row -->
          <tr *ngIf="rowExpanded(v.idVacante)">
            <td colspan="8" style="padding:0;background:#111827;">
              <!-- Loading -->
              <div *ngIf="rowLoading(v.idVacante)"
                   style="padding:20px 48px;color:#475569;font-size:13px;text-align:center;">
                Cargando candidatos…
              </div>
              <!-- Empty -->
              <div *ngIf="!rowLoading(v.idVacante) && getPostulantes(v.idVacante).length === 0"
                   style="padding:16px 48px;color:#475569;font-size:13px;">
                Sin postulaciones para esta vacante.
              </div>
              <!-- Sub-table -->
              <table *ngIf="!rowLoading(v.idVacante) && getPostulantes(v.idVacante).length > 0"
                     style="width:100%;border-collapse:collapse;font-size:12px;">
                <thead>
                  <tr style="background:#1e2d42;">
                    <th style="padding:8px 12px 8px 48px;text-align:left;color:#64748b;font-weight:600;">Candidato</th>
                    <th style="padding:8px 12px;text-align:left;color:#64748b;font-weight:600;">Correo</th>
                    <th style="padding:8px 12px;text-align:left;color:#64748b;font-weight:600;">Teléfono</th>
                    <th style="padding:8px 12px;text-align:left;color:#64748b;font-weight:600;">Ciudad</th>
                    <th style="padding:8px 12px;text-align:left;color:#64748b;font-weight:600;">Fecha</th>
                    <th style="padding:8px 12px;text-align:center;color:#64748b;font-weight:600;">Estatus</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let p of getPostulantes(v.idVacante)"
                      style="border-top:1px solid #1e293b;">
                    <td style="padding:8px 12px 8px 48px;color:#e2e8f0;font-weight:500;">
                      {{p.nombre?.trim() || '—'}}
                    </td>
                    <td style="padding:8px 12px;color:#94a3b8;">{{p.correo || '—'}}</td>
                    <td style="padding:8px 12px;color:#94a3b8;">{{p.telefono || '—'}}</td>
                    <td style="padding:8px 12px;color:#94a3b8;">{{p.ciudad || '—'}}</td>
                    <td style="padding:8px 12px;color:#64748b;white-space:nowrap;">
                      {{formatDate(p.fechaPostulacion)}}
                    </td>
                    <td style="padding:8px 12px;text-align:center;">
                      <span [style.background]="p.estatus === 'PENDIENTE' ? '#2d2a0c' : '#1c3229'"
                            [style.color]="p.estatus === 'PENDIENTE' ? '#fbbf24' : '#4ade80'"
                            style="display:inline-block;padding:2px 7px;border-radius:4px;font-size:11px;font-weight:600;text-transform:uppercase;">
                        {{p.estatus}}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>

  </div><!-- /tg-container -->
</div><!-- /table wrapper -->

<!-- ── Pagination ─────────────────────────────────────────────────────────── -->
<div *ngIf="totalPages > 1"
     style="background:#1e293b;padding:14px 0;border-top:1px solid #334155;">
  <div class="tg-container" style="display:flex;align-items:center;justify-content:center;gap:6px;">

    <button (click)="ir(0)" [disabled]="page === 0" class="pg-btn">«</button>
    <button (click)="ir(page-1)" [disabled]="page === 0" class="pg-btn">‹</button>

    <button *ngFor="let p of pageNums" (click)="ir(p)"
            class="pg-btn" [class.pg-btn--active]="p === page">
      {{p + 1}}
    </button>

    <button (click)="ir(page+1)" [disabled]="page >= totalPages-1" class="pg-btn">›</button>
    <button (click)="ir(totalPages-1)" [disabled]="page >= totalPages-1" class="pg-btn">»</button>

  </div>
</div>
